export const UNAVAILABLE_CONTEXT_ERROR = 'React Context is unavailable in Server Components';
